module.exports = __webpack_public_path__ + "img/ascenti-mosaic-logo.22da03b9.png";